import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { Alert, AlertBody, AlertDescription, AlertIcon } from '@bonusly/design-system';

import { DateInput } from '../../../../../../components/growth/meeting-modal/components/event-form/date-input';
import { TimeInput } from '../../../../../../components/growth/meeting-modal/components/event-form/time-input';

interface RescheduleDatePickerProps {
	availableRangeDays: number;
}

export const RescheduleDatePicker: FC<RescheduleDatePickerProps> = ({ availableRangeDays }) => {
	const {
		formState: { errors: formErrors },
	} = useFormContext();

	return (
		<>
			<DateInput availableRangeDays={availableRangeDays} />
			<TimeInput />

			{(formErrors.startTime || formErrors.endTime) && (
				<Alert status="error" size="sm">
					<AlertIcon />

					<AlertBody>
						<AlertDescription>{formErrors.startTime ? String(formErrors.startTime.message) : String(formErrors.endTime?.message ?? '')}</AlertDescription>
					</AlertBody>
				</Alert>
			)}
		</>
	);
};
